import Vue from 'vue'

Vue.mixin({
	methods: {
		permissionCheck: function (path, type) {
			return this.$store.state.AppActiveUser.permissions.includes(`${path}.${type}`);
			// return this.$store.state.AppActiveUser.userRole == 'ADMIN' || this.$store.state.AppActiveUser.permissions.includes(`${path}.${type}`);
		},
		elapsedTime: function (startTime) {
			let x = new Date(startTime)
			let now = new Date()
			var timeDiff = now - x
			timeDiff /= 1000
			
			var seconds = Math.round(timeDiff)
			timeDiff = Math.floor(timeDiff / 60)
			
			var minutes = Math.round(timeDiff % 60)
			timeDiff = Math.floor(timeDiff / 60)
			
			var hours = Math.round(timeDiff % 24)
			timeDiff = Math.floor(timeDiff / 24)
			
			var days = Math.round(timeDiff % 365)
			timeDiff = Math.floor(timeDiff / 365)
			
			var years = timeDiff
			
			if (years > 0) {
				return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
			} else if (days > 0) {
				return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
			} else if (hours > 0) {
				return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
			} else if (minutes > 0) {
				return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
			} else if (seconds > 0) {
				return seconds + (seconds > 1 ? ' sec ago' : 'just now')
			}
			
			return 'Just Now'
		},
		// Method for creating dummy notification time
		randomDate: function ({ hr, min, sec }) {
			let date = new Date()
			
			if (hr) date.setHours(date.getHours() - hr)
			if (min) date.setMinutes(date.getMinutes() - min)
			if (sec) date.setSeconds(date.getSeconds() - sec)
			
			return date
		},
		formatDate: function (date) {
			if(date && date != '0000-00-00') {
				return this.$moment.utc(date).format('DD-MM-YYYY HH:mm:ss')
			}
			else {
				return date
			}
		},
		capitalizeFirstLetter: function (s) {
			if(typeof s !== 'string') {
				return ''
			}
			else {
				return s.split(' ').map(w => w.substring(0, 1).toUpperCase() + w.substring(1)).join(' ')
			}
		},
		convertToSlug: function(s) {
			if(typeof s !== 'string') {
				return ''
			}
			else {
				// eslint-disable-next-line no-useless-escape
				return s.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
			}
		},
		getQueryVariable: function (variable) {
			let query = window.location.search.substring(1);
			let vars = query.split("&");
			for (let i = 0; i < vars.length; i++) {
				let pair = vars[i].split("=");
				if (pair[0] == variable) {
					return pair[1];
				}
			}
			return (false);
		},
		pushToArray: function (arr, obj, prop) {
			let index = arr.findIndex((e) => e[prop] === obj[prop]);
			// Check & Push to Array
			if (index === -1) {
				arr.push(obj);
			} else {
				arr.splice(index, 1, obj);
			}
		},
		removeFromArray: function (arr, obj, prop) {
			let index = arr.findIndex((e) => e[prop] === obj[prop]);
			// Check & Delete from Array
			if (index !== -1) {
				arr.splice(index, 1);
			}
		}
	}
});
